/*
// флаги готовности счетчиков
let counters = {
    ga: false,
    ya: false
};

// прверка все ли счетчики загружены
$(document).on('counter:ready', function (e, data) {
    if (counters[data] != undefined) {
        counters[data] = true;
        for(let key in counters) {
            if (counters[key] == false) {
                return;
            }
        }
        jQuery(document).trigger('counters:ready');
    }
});
*/

// запоминаем вызовы счетчика до его инициализации
window.gaCounterQueue = [];
window.gaCounter = function () {
    window.gaCounterQueue.push([].slice.call(arguments));
};

$(document).on('ga:ready', function () {
    let is_admin = window.is_admin;
    let clientID;
    let sessionID;

    // Получаем переменную clientId из гугл-аналитики (https://ru.advertisercommunity.com/t5/Stati/4-sposoba-poluchit-cid-Client-ID-polzovatelya-Google-Analytics/ba-p/109199#)
    ga(function(tracker) {
        clientID = tracker.get('clientId');

        // Получаем переменную sessionID
        if (clientID) {
            sessionID = clientID + '_' + new Date().getTime();
            $(document).trigger('ga:clientID', clientID);
        }

        window.clientIdGA = clientID;
        sendStatistic();

        // Только после этого запускаем счётчик яндекса со своими параметрами
        window.initYaCounter(document, window, 'yandex_metrika_callbacks', [clientID, sessionID]);
    });

    // Отправляем статистику
    function sendStatistic() {
        ga('send', 'pageview', {
            'dimension1': 'traffic_by_admin_' + is_admin,
            'dimension2': clientID,
            'dimension3': sessionID
        });
    }

    // выполняем сохраненные вызовы счетчика сделанные до инициализации
    window.gaCounterQueue.forEach(function (arr) {
        ga.apply(null, arr);
    });
    window.gaCounter = function() {
        window.ga.apply(null, arguments);
    };
    delete window.gaCounterQueue;
});

// запоминаем вызовы счетчика до его инициализации
window.yaCounter = {
    queue: [],
    reachGoal: function () {
        let arr = [].slice.call(arguments);
        arr.unshift('reachGoal');
        this.queue.push(arr);
    }
};

// выполняем сохраненные вызовы счетчика сделанные до инициализации
$(document).on('ya:ready', function (e, ya) {
    requestAnimationFrame(function () {
        window.yaCounter.queue.forEach(function (arr) {
            let action = arr.shift();
            ya[action].apply(null, arr);
        });
        window.yaCounter = ya;
    });
});

// отправка целей по событиям
$(document).on('counters:main_advantages_block_show', function () {
    gaCounter("send", "event", "main_advantages_block", "show");
    yaCounter.reachGoal("main_advantages_block_show");
});

$(document).on('counters:main_advantages_block_click', function () {
    gaCounter("send", "event", "main_advantages_block", "click");
    yaCounter.reachGoal("main_advantages_block_click");
});

$(document).on('counters:main_vacancies_block_show', function () {
    gaCounter("send", "event", "main_vacancies_block", "show");
    yaCounter.reachGoal("main_vacancies_block_show");
});

$(document).on('counters:main_vacancies_block_click', function (e, data) {
    gaCounter("send", "event", "main_vacancies_block", "click", data);
    yaCounter.reachGoal("main_vacancies_block_click");
});